import React from 'react'
import '../styles/articles.css'
import Currency from '../images/image-currency.jpg'
import Restaurant from '../images/image-restaurant.jpg'
import Plane from '../images/image-plane.jpg'
import Contfetti from '../images/image-confetti.jpg'
const Articles = () => {
	return <div className="articles">
		<div className="articles__container">
			<h3>Latest Articles</h3>
			<div className="articles__cards">
				<div className="article__card">
					<div className="article__card__image">
						<img src={Currency} />
					</div>
					<div className="article__card__infos">
						<h5>By Claire Rabinson</h5>
						<h4>Receive money in any currency with no fees</h4>
						<p>
							The world is getting smaller and we're becomming more mobile, so why should you be forced to only receive money in a single...
						</p>
					</div>
				</div>

				<div className="article__card">
					<div className="article__card__image">
						<img src={Restaurant} />
					</div>
					<div className="article__card__infos">
						<h5>By Wilson Hatton</h5>
						<h4>Treat yourself without worrying about money</h4>
						<p>
							Our simple budgeting feature allows you to seperate out your spending and set realistic limits each month. That means you...
						</p>
					</div>
				</div>

				<div className="article__card">
					<div className="article__card__image">
						<img src={Plane} />
					</div>
					<div className="article__card__infos">
						<h5>By Wilson Hatton</h5>
						<h4>Take your Easybank card where you go</h4>
						<p>
							We want you to enjoy your travels. this is hwy we don't charge any fees on purchases while you 're abroad. We'll even show you...
						</p>
					</div>
				</div>

				<div className="article__card">
					<div className="article__card__image">
						<img src={Contfetti} />
					</div>
					<div className="article__card__infos">
						<h5>By Claire Rabinson</h5>
						<h4>Our invite-only Beta accounts are now live!</h4>
						<p>
							After a lot of hard work by the whole team, we're excited to launch our closed beta. It's easy to request an invite through the site...
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
}

export default Articles;